import React, { Component } from "react";

class Kontakty extends Component {
  render() {
    return <h1>Kontakty w budowie...</h1>;
  }
}

export default Kontakty;
